import { schemes, zSchema } from "@zeal/common";

export const downloadLaborPosterTemplateRequestSchema = zSchema.object({
  ids: zSchema.array(schemes.uuid()),
});

export type TDownloadLaborPosterTemplateRequestSchema = zSchema.infer<
  typeof downloadLaborPosterTemplateRequestSchema
>;
